import(/* webpackMode: "eager" */ "/Users/ginkgoretail/Documents/Disk-A/Alfa Mall/comverse-baseapp-next/app/error.jsx");
